export default "__VITE_ASSET__BOukID_3__"